import "./App.css";
import { Switch, Route, Redirect } from "react-router-dom";
import AddCategory from "./Components/category/AddCategory";
import Banner from "./Components/banner/Banner";
import UserList from "./Components/UserList";
import ProductList from "./Components/product/ProductList";
import ConfigScreen from "./Components/screens/Config";
import Orders from "./Components/screens/Orders";
import More from "./Components/screens/More";
import Home from "./Components/screens/Home";
import FeedList from "./Components/feed/FeedList";

function AppContainer() {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/home" />
      </Route>
      <Route exact path="/home">
        <Home />
      </Route>
      <Route exact path="/app/banner">
        <Banner />
      </Route>
      <Route exact path="/app/feed">
        <FeedList />
      </Route>
      <Route exact path="/products">
        <ProductList />
      </Route>
      <Route exact path="/users">
        <UserList />
      </Route>
      <Route exact path="/categories">
        <AddCategory />
      </Route>
      <Route exact path="/config">
        <ConfigScreen />
      </Route>
      <Route exact path="/orders">
        <Orders />
      </Route>
      <Route exact path="/more">
        <More />
      </Route>
    </Switch>
  );
}

export default AppContainer;
